import LoginView from '@/pages/login.vue'

export default {
  path: '/login',
  name: 'Login',
  component: LoginView,
  meta: {
    anonymous: true,
  },
}
